module.exports = __webpack_public_path__ + "img/step_01.5b278921.png";